export const metricNamespace: string = "SMSWOUnifiedDashboardWebsite"
export const metricPageNames = {
    workflowInstanceListView: "workflowInstanceListView",
    workflowDetailView: "workflowDetailView",
    startWorkflowInstance: "startWorkflowInstance",
    restartWorkflowInstance: "restartWorkflowInstance",
    createAdhocTicket: "createAdhocTicket",
    workflowAttemptsView: "workflowAttemptsView",
    workflowAggregateInstanceView: "workflowAggregateInstanceView",
    homePage: "homePage",
    programSummary: "programSummary",
    programDetails: "programDetails",
    workflowList: "workflowList",
    programSourceRepository: "programSourceRepository",
    websiteView: "websiteView"
}
export const metricFeaturesList = {
    terminateWorkflowInstance: "terminateWorkflowInstance",
    bulkTerminateWorkflowInstance: "bulkTerminateWorkflowInstance",
    restartWorkflowInstance: "restartWorkflowInstance",
    bulkRestartWorkflowInstance: "bulkRestartWorkflowInstance",
    republishWorkflowInstance: "republishWorkflowInstance",
    observeWorkflowInstance: "observeWorkflowInstance",
    bulkObserveWorkflowInstance: "bulkObserveWorkflowInstance",
    redirectURL: "redirectURL",
    outputWorkitem: "outputWorkitem",
    showSubStage: "showSubStage",
    showSubStageCard: "showSubStageCard",
    showEventsPopup: "showEventsPopup",
    index: "index",
    bulkStart: "bulkStart",
    adhocStart: "adhocStart",
    scheduleStart: "scheduleStart",
    page0: 'page0',
    productSummary: 'productSummary',
    programDetailsFailure: "programDetailsFailure",
    programDetailsRunning: "programDetailsRunning",
    page2ListView: "workflowList",
    websiteAnalysisAndDiagnosticTool: "websiteAnalysisAndDiagnosticTool"
}

export const additionalAttributes = {
    isRestartOverrideInput: "isRestartOverrideInput"
}
